import {
  TriageQuestion,
  Topic,
  ConsoleMessages,
  ConsoleWrapperAttachPoints
} from 'lib/amwell/sdk/types';

export interface UpdateVisitContextForm {
  shareHealthSummary: boolean;
  triageQuestions: TriageQuestion[];
  callbackNumber: string;
  disclaimersAcknowledged: boolean;
  otherTopic: string;
  topics: Topic[];
}

export enum VisitStep {
  INIT = 'init',
  SETUP = 'setup',
  PROCESSING = 'processing',
  STARTED = 'started',
  FINISHED = 'finished'
}

export enum VisitType {
  WEB_RTC = 'webRTC',
  TELEHEALTH_VIDEO = 'telehealthVideo'
}

export interface WebRTCContextElements {
  messages: ConsoleMessages;
  consoleWrapperAttachPoints?: ConsoleWrapperAttachPoints;
  videoConsoleContainer: HTMLElement;
}
